import INFTCollections from '../../models/INFTCollections'
import DeproApeCryptoClubCard from '../../nftFormats/DeproApeCryptoClub/Card/DeproApeCryptoClubCard'
import DeproApeCryptoClubDetail from '../../nftFormats/DeproApeCryptoClub/Detail/DeproApeCryptoClubDetail'
import DeproApeCryptoClubActivtyDetail from '../../nftFormats/DeproApeCryptoClub/Activity/DeproApeCryptoClubActivtyDetail'
import DeproApeCryptoClubLogo from '../../../../assets/nft-logo/DeproApeCryptoClub.jpg'

export const DeproApeCryptoClubData: INFTCollections[] = [
  {
    id: 'DeproApeCryptoClub',
    tokenAddress: '0x91e0119d077a676f69ba6d3895cfd39c49903b8f',
    name: 'DeproApeCryptoClub',
    cardFormat: DeproApeCryptoClubCard,
    detailFormat: DeproApeCryptoClubDetail,
    activityFormat: DeproApeCryptoClubActivtyDetail,
    category: 1,
    creatorAddress: '0x6000ee5cf3f9ad60c712da8ad5989aacb1794f02',
    logo: DeproApeCryptoClubLogo,
    website: 'https://www.deproapecc.com/',
    twitter: 'DeproApeCC',
    telegram: 'https://t.me/DeproApeCC',
    discord: 'https://discord.com/invite/c72zzEKwmc',
    forkProject: true
  }
]

export const DeproApeCryptoClubCategoryData = {
  [DeproApeCryptoClubData[0].tokenAddress.toLowerCase()]: DeproApeCryptoClubData[0].category
}
